import React from 'react';
import RadioButtonGroup from '../../../../../generic/Form/Compound/RadioButtonGroup';
import useFilterWrapper from '../../../../../../hooks/generic/FilterUI/useFilterWrapper';
import { useSelector, useDispatch } from '../../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import { safeMutate } from '../../../../../../utils/GeneralUtils';

const MeetingMode = ({ filterTitle, filterData }) => {
  const selectedMeetingModeValue = useSelector(state => state.eventsListing.filters.meetingMode);
  const selectedMeetingModeLabel = filterData.find(data => data.value === selectedMeetingModeValue).label;
  const dispatch = useDispatch();
  const updatedFilterData = safeMutate(filterData, draftFilterData => {
    draftFilterData.find(data => data.value === selectedMeetingModeValue).checked = true;
  });

  const onChangeHandler = (_event, _childUId, childData) => {
    filterWrapperActions.filterBodyVisibilitySetter(false);
    let selectedMeetingMode = childData.find(choice => choice.checked === true)
    dispatch(eventsListingActions.updateMeetingMode(selectedMeetingMode.value));
  };

  const [FilterWrapper, filterWrapperOptions, filterWrapperActions] = useFilterWrapper({});

  return (
    <FilterWrapper
      title={ filterTitle }
      currentValue={ selectedMeetingModeLabel }
      showFilter
      rounded
      bodyClass='cui-border-radius-6'
      headerWidthClass='custom-max-width-15'
      { ...filterWrapperOptions }
    >
      <RadioButtonGroup
        data={ updatedFilterData }
        onChange={ onChangeHandler }
      />
    </FilterWrapper>
  )
}

export default MeetingMode;